import { render, staticRenderFns } from "./ChatFooter.vue?vue&type=template&id=71a69f83&"
import script from "./ChatFooter.vue?vue&type=script&lang=js&"
export * from "./ChatFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports